// extracted by mini-css-extract-plugin
export var brandPageButton = "product-info-module--brand-page-button--qhd12";
export var button = "product-info-module--button--o7Hbj";
export var buttonContainer = "product-info-module--button-container--XkbNT";
export var desc = "product-info-module--desc--TxPTP";
export var productCheckbox = "product-info-module--product-checkbox--eUsdx";
export var productPopup = "product-info-module--product-popup--lkhkU";
export var productSize = "product-info-module--product-size--tBJWT";
export var productSizeContainer = "product-info-module--product-size-container--B0RJv";
export var title = "product-info-module--title--4ik1s";